export const STATE_NAME = 'transactionsHistory';
export const TRANSACTIONS_PER_PAGE = 10;
export const REFERENCE_NUM_LEN = 9;
